/* eslint-disable react/prop-types */
/* eslint-disable react/self-closing-comp */
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button, Grid, Table, Checkbox } from 'semantic-ui-react';
import { openModal } from '../../redux/modals/modalReducer';

const ComplaintDetail = ({ data, userList }) => {
  const dispatch = useDispatch();

  return (
    <>
      <Grid>
        <Grid.Column width={16}>
          <Table compact celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell />
                <Table.HeaderCell>Statut</Table.HeaderCell>
                <Table.HeaderCell>Objet</Table.HeaderCell>
                <Table.HeaderCell>Type du plaignant</Table.HeaderCell>
                <Table.HeaderCell>Compagnie</Table.HeaderCell>
                <Table.HeaderCell>Responsable</Table.HeaderCell>
                <Table.HeaderCell>Date Creation</Table.HeaderCell>
                <Table.HeaderCell>Detail</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {data &&
                data.complaintByStatut.items &&
                data.complaintByStatut.items.map((complaint) => (
                  <Table.Row key={complaint.confirmation}>
                    <Table.Cell collapsing>
                      <Checkbox slider />
                    </Table.Cell>
                    <Table.Cell> {complaint.statut}</Table.Cell>
                    <Table.Cell> {complaint.object}</Table.Cell>
                    <Table.Cell> {complaint.complaintType}</Table.Cell>
                    <Table.Cell> {complaint.company}</Table.Cell>
                    <Table.Cell> {complaint.responsable}</Table.Cell>
                    <Table.Cell> {complaint.createdAt}</Table.Cell>
                    <Table.Cell>
                      {complaint.responsable ? (
                        <Button
                          basic
                          color="green"
                          as={NavLink}
                          to={`/dashboard/admin-complaint-view/${complaint.confirmation}`}
                        >
                          {' '}
                          Traiter
                        </Button>
                      ) : (
                        <Button
                          basic
                          color="blue"
                          onClick={() =>
                            dispatch(
                              openModal({
                                modalType: 'ModalComplaintResponsable',
                                modalProps: { complaint, userList }
                              })
                            )
                          }
                        >
                          Affecter
                        </Button>
                      )}
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
            <Table.Footer fullWidth>
              <Table.Row>
                <Table.HeaderCell />
                <Table.HeaderCell colSpan="8" textAlign="center"></Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
        </Grid.Column>
      </Grid>
    </>
  );
};

export default ComplaintDetail;
